<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
      <div class="col-md-8 ps-5">
        <h2 class="col pb-2 title">
          {{ "ONDEMANDCUSTOMREGISTER" | translate }}
        </h2>
        <h6 class="col subtitle">
          {{ "ONDEMANDCUSTOMREG_SUBTITLE" | translate }}
        </h6>
      </div>
      @if (
      authService.isAuthorized([PermissionEnum.Ondemand_loadprofile_execute])
      ) {
      <div class="col-md-4 pe-5 d-flex justify-content-end align-items-center"
        [routerLink]="['/on-demand/custom-register-setup']">
        <button class="button-add-device">
          {{ "ONDEMANDCAPS" | translate }}
        </button>
      </div>
      }
    </div>
    <div class="row g-0 m-0">
      <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
        <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
        <app-status [statuses]="commandStatuses" class="pe-2" (close)="onStatusOption($event)"></app-status>

        <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
          (searchChange)="searchChange($event)"></app-search>
      </div>
      <div class="row g-0 m-0 pt-3">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_SERVICENAME" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "ENERGYREGISTERS_METERNO" | translate }}</span>
              </th>
              <th class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DATE" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "TIME" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "STATUS" | translate }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data; let i=index" (click)="handleRowClick(row.id, row.meterNo, row.status)">
              <td appIsNew [executedTime]="row.startTime!" [seconds]="dayInMs"></td>
              <td>
                <span>{{ row.assetType }}</span>
              </td>
              <td>
                <span>{{ row.serviceName }}</span>
              </td>
              <td>
                <span (click)="clipboardService.copyToClipboard(row.meterNo!, $event, i)" class="copyable">
                  {{ row.meterNo }}
                  <span class="copy-tooltip" *ngIf="clipboardService.copiedText === i.toString()">{{"COPIED" |
                    translate}}</span>
                </span>
              </td>
              <td>
                <span>{{ row.startTime | date: "EEE MMM dd yyyy" }}</span>
              </td>
              <td>
                <span>{{ row.startTime | date: "shortTime" }}</span>
              </td>
              <td>
                <div class="status-container">
                  <span (click)="printResponseOfCommand($event, row)" class="text-wrapper" [ngClass]="{
                      'status-pending': row.status === 'Pending',
                      'status-in-progress': row.status === 'InProgress',
                      'status-completed': row.status === 'Success' || row.status === 'Finalize',
                      'status-failed': row.status === 'Failed',
                      'status-fatal-error': row.status === 'ErrorOccured',
                    }">
                    {{ row.status === 'ErrorOccured' ? ('FATAL_ERROR' | translate) : row.status }}
                  </span>
                  @if (
                  row.status === "Failed" &&
                  authService.isAuthorized([
                  PermissionEnum.Ondemand_loadprofile_execute,
                  ])
                  ) {
                  <svg-icon class="retry-icon" src="assets/device/refresh.svg" (click)="retryCommand(row)"
                    title="Retry command">
                  </svg-icon>
                  }
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="container-down">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
      [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
  </div>
</div>